module.exports = __webpack_public_path__ + "img/ditu2.996bbf7e.png";